import { Badge } from "antd";
import styled from "styled-components";

export const StyledBadge = styled(Badge)`
    color: inherit;

    .ant-badge-count {
        background-color: ${({ theme }) => theme.colors.primary};
    }
`;
